// Ссылка на оплату: УК даёт свою (эквайринг, банк, платёжный сервис), Smena подставляет сумму.
//
// Поддерживаем две формы, потому что сервисы устроены по-разному:
//   1. Шаблон с плейсхолдером - https://pay.example/x?sum={amount}&order={booking}
//   2. Просто ссылка - https://pay.example/x → сумма добавится параметром ?amount=…
//
// Ссылка уходит гостю ТОЛЬКО через слот (ADR-7): сервер сам подставляет сумму, а url-guard
// в резолвере не пропустит ссылку, которой нет в значениях слотов. Поэтому модель не может
// ни выдумать ссылку, ни исказить сумму - максимум не поставить плейсхолдер.

export interface PaymentLinkContext {
  amount: number;
  /** Номер брони - если в шаблоне есть {booking}. */
  bookingId?: string;
}

/** Имя query-параметра, если в шаблоне нет плейсхолдера. */
const DEFAULT_AMOUNT_PARAM = 'amount';

/**
 * Собирает ссылку на оплату. Возвращает null, если ссылка не настроена или настроена
 * неверно: тогда слот недоступен, конвейер эскалирует и гость не получит битую ссылку.
 */
export function buildPaymentLink(
  template: string | undefined | null,
  ctx: PaymentLinkContext,
): string | null {
  const raw = String(template ?? '').trim();
  if (!raw) return null;

  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;

  const amount = Math.max(0, Math.round(ctx.amount));
  if (!Number.isFinite(amount) || amount <= 0) return null;

  const hasAmountPlaceholder = raw.includes('{amount}');
  let result = raw
    .replaceAll('{amount}', String(amount))
    .replaceAll('{booking}', encodeURIComponent(ctx.bookingId ?? ''));

  if (!hasAmountPlaceholder) {
    const withParam = new URL(result);
    withParam.searchParams.set(DEFAULT_AMOUNT_PARAM, String(amount));
    result = withParam.toString();
  }

  // Проверяем, что после подстановки ссылка осталась валидной (шаблон мог быть кривым).
  try {
    new URL(result);
  } catch {
    return null;
  }
  return result;
}

/** Как ссылка будет выглядеть для гостя - для превью в настройках. */
export function previewPaymentLink(template: string | undefined | null, amount = 3500): string | null {
  return buildPaymentLink(template, { amount, bookingId: 'B-1042' });
}
